import React, { useState, useContext, useRef } from "react";
import { Navbar } from "reactstrap";
import Icon from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/fontawesome-free-solid";
import TitleContext from "../../context/TitleContext";

const Header = props => {
  const togglerRef = useRef(null);
  const [sidebarExists, setSidebarExists] = useState(false);
  const mobileSidebarToggle = e => {
    if (sidebarExists === false) {
      setSidebarExists(true);
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  };
  const { title } = useContext(TitleContext);
  return (
    <Navbar className="navbar-default" expand="lg">
      <div className="navbar-toggle">
        <div
          ref={togglerRef}
          className="navbar-toggler"
          onClick={mobileSidebarToggle}
        >
          <Icon icon={faBars} color="#fff" />
        </div>
      </div>
      <p className="navbar-brand">{title}</p>
    </Navbar>
  );
};

export default Header;
